<template>
    <section id="sobre" class="about section-panel">
        <div class="section-kicker">Sobre a Aeonsoft</div>
        <div class="about-grid">
            <div>
                <h2>Consultoria e sistemas sob demanda.</h2>
                <p>
                    A <strong>Aeonsoft</strong> é uma empresa de tecnologia com mais de 15 anos de atuação no mercado,
                    apoiando negócios que precisam transformar desafios complexos em sistemas confiáveis,
                    escaláveis e prontos para operação.
                </p>
                <p>
                    Ao longo dessa trajetória, prestamos consultoria para inúmeras empresas, instituições
                    financeiras e bancos, participando de projetos críticos e de alto impacto. Entre eles,
                    contribuímos com iniciativas importantes para o governo brasileiro, incluindo a
                    implementação do PIX em instituições financeiras.
                </p>
                <p>
                    Nosso trabalho combina visão técnica, proximidade com o cliente e execução pragmática:
                    desenhamos, desenvolvemos e evoluímos soluções sob demanda para empresas que precisam
                    de tecnologia feita para o seu contexto real.
                </p>
            </div>
            <aside class="about-metrics" aria-label="Números da Aeonsoft">
                <div>
                    <header>
                        <span class="metric-icon" aria-hidden="true">
                            <svg viewBox="0 0 24 24">
                                <path d="M7 3v3M17 3v3M4.5 9h15M6 5h12a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z" />
                                <path d="M8 14h3M13 14h3M8 17h3" />
                            </svg>
                        </span>
                        <strong>Empresa consolidada</strong>
                    </header>
                    <span>há mais de 15 anos atuando no mercado de tecnologia</span>
                </div>
                <div>
                    <header>
                        <span class="metric-icon" aria-hidden="true">
                            <svg viewBox="0 0 24 24">
                                <path d="M4 7h16M6 7v12M18 7v12M3 19h18" />
                                <path d="M8 11h2M8 15h2M14 11h2M14 15h2" />
                                <path d="M12 3 4 7h16l-8-4Z" />
                            </svg>
                        </span>
                        <strong>Projetos de impacto</strong>
                    </header>
                    <span>participação em projetos de relevância nacional, como a implementação do PIX em instituições financeiras</span>
                </div>
                <div>
                    <header>
                        <span class="metric-icon" aria-hidden="true">
                            <svg viewBox="0 0 24 24">
                                <path d="M4 7h16v10H4z" />
                                <path d="M8 21h8M12 17v4M8 11h3M13 11h3M8 14h8" />
                            </svg>
                        </span>
                        <strong>Sistemas sob medida</strong>
                    </header>
                    <span>tocamos seu projeto da ideia ao MVP, da arquitetura à produção</span>
                </div>
            </aside>
        </div>
    </section>
</template>

<script>
export default {
    name: 'About'
}
</script>

<style scoped>
.about-grid {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 18rem;
    gap: 2rem;
    align-items: start;
}

h2 {
    color: white;
    font-family: "Sora", sans-serif;
    font-size: clamp(2rem, 4vw, 3.3rem);
    line-height: 1.05;
    margin-bottom: 1.2rem;
}

p {
    color: rgba(255, 255, 255, .76);
    font-size: 1.04rem;
    line-height: 1.75;
    margin-bottom: 1rem;
}

.about-metrics {
    display: grid;
    gap: .85rem;
}

.about-metrics div {
    border: 1px solid rgba(255, 255, 255, .14);
    background:
        linear-gradient(145deg, rgba(255, 255, 255, .13), rgba(255, 255, 255, .055)),
        rgba(255, 255, 255, .045);
    border-radius: .5rem;
    padding: 1rem;
}

.about-metrics header {
    display: flex;
    align-items: center;
    gap: .7rem;
    margin-bottom: .65rem;
}

.metric-icon {
    display: inline-grid;
    place-items: center;
    flex: 0 0 auto;
    width: 2.15rem;
    height: 2.15rem;
    border-radius: .5rem;
    color: white;
    background: rgba(255, 255, 255, .1);
}

.metric-icon svg {
    width: 1.25rem;
    height: 1.25rem;
    fill: none;
    stroke: currentColor;
    stroke-width: 1.8;
    stroke-linecap: round;
    stroke-linejoin: round;
}

.about-metrics strong {
    display: block;
    color: white;
    font-family: "Sora", sans-serif;
    font-size: 1.18rem;
    line-height: 1.2;
    margin-bottom: 0;
}

.about-metrics span {
    color: rgba(255, 255, 255, .68);
    line-height: 1.45;
}

@media screen and (max-width: 820px) {
    .about-grid {
        grid-template-columns: 1fr;
    }
}
</style>
